// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N30A, N700 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { WEEK_DAY_COUNT, WEEK_MIN_HEIGHT } from './constants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Header = styled.div({
	display: 'flex',
	marginBottom: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DaySkeleton = styled.div({
	display: 'flex',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${100 / WEEK_DAY_COUNT}%`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WeekSkeletonContainer = styled.div({
	borderLeft: `1px solid ${token('color.border', N30A)}`,
	borderTop: `1px solid ${token('color.border', N30A)}`,
	display: 'grid',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	gridTemplateColumns: `repeat(7, ${100 / WEEK_DAY_COUNT}%)`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WeeksSkeleton = styled.div({
	borderBottom: `1px solid ${token('color.border', N30A)}`,
	borderRight: `1px solid ${token('color.border', N30A)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${WEEK_MIN_HEIGHT}px`,
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.150', '12px'),
	padding: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Day = styled.h6({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${100 / WEEK_DAY_COUNT}%`,
	color: token('color.text.subtlest', N700),
	margin: 0,
	textAlign: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Weeks = styled.div({
	borderRadius: token('border.radius.100', '3px'),
	borderLeft: `1px solid ${token('color.border', N30A)}`,
	borderTop: `1px solid ${token('color.border', N30A)}`,
	width: '100%',
});
